import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAllFile } from "@/api/fileOperation";
export default {
  name: "Export",
  data: function data() {
    return {
      excelList: []
    };
  },
  methods: {
    initPage: function initPage() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getAllFile();
            case 1:
              res = _context.sent;
              if (res.code === 0) _this.excelList = res.data.list;
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    Copy: function Copy(link) {
      var inp = document.createElement("input");
      inp.value = link;
      document.body.appendChild(inp);
      inp.select(); // 选择对象;
      var res = document.execCommand("Copy"); // 执行浏览器复制命令
      if (res) this.$message.success("链接复制成功, 请打开浏览器粘贴链接下载表格");else this.$message.error("链接复制失败, 请再次点击复制链接");
      inp.remove();
    },
    exportExcel: function exportExcel(link) {
      location.href = process.env.VUE_APP_BASE_API + link;
    }
  },
  created: function created() {
    this.initPage();
  }
};